import React from "react";
import { BlogCardStyles } from "../Styles";
import { useNavigate } from "react-router-dom";
import ShareIcon from "@mui/icons-material/Share";
import { Box, Card, IconButton, Typography, CardContent } from "@mui/material";

const BlogCards = ({
  blogTitle,
  blogImage,
  blogHeading,
  blogDescription,
  blogCreatedDate,
  blogId,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => navigate(`/blogdetails/${blogId}`)}
      sx={{ cursor: "pointer" }}
    >
      <Card elevation={2} sx={BlogCardStyles.BlogParentCardContainer}>
        <Box sx={BlogCardStyles.BlogTitle}>{blogTitle}</Box>

        <Box
          component="img"
          src={blogImage}
          alt="Blog Visual"
          sx={BlogCardStyles.BlogImages}
        />

        <CardContent align="justify" sx={{}}>
          <Typography
            gutterBottom
            variant="body"
            sx={[BlogCardStyles.BlogHeadingTxt]}
          >
            {blogHeading}
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={BlogCardStyles.BlogDescriptionTxt}
          >
            {blogDescription}
          </Typography>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="caption"
              sx={BlogCardStyles.BlogCreatedDateTxt}
            >
              {blogCreatedDate}
            </Typography>

            <IconButton size="small" color="primary">
              <ShareIcon fontSize="small" />
            </IconButton>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BlogCards;
